import { useState } from "react";
import SpeakerMode from "./SpeakerMode";

export default function SpeakerModeWrapper() {
    const [segments, setSegments] = useState([]);
    const [showInput, setShowInput] = useState(false);
    const [segmentInput, setSegmentInput] = useState("");

    return (
        <SpeakerMode
            segments={segments}
            setSegments={setSegments}
            showInput={showInput}
            setShowInput={setShowInput}
            segmentInput={segmentInput}
            setSegmentInput={setSegmentInput}
        />
    );
}
